import logo from "../assets/full_logo_with_tm.png";
import phone from "../assets/telephone.png";
import whatsapp from "../assets/whatsapp-logo-png-2259.png";
import mail from "../assets/mail.png";
import apple from "../assets/apple-logo.png";
import play from "../assets/playstore.png";
import search from "../assets/magnifying-glass black.png";
// import banner1 from '../assets/female-sales-person-jewelry-shop.png'
// import banner2 from '../assets/indoor-studio-photo-elegant-brunette-woman-stylish-dress-standing-urban-concrete-wall.png'
// import BIS from '../assets/BIS-Hallmark-Color.png';
import delivery_van from '../assets/fast-delivery.png';
import Exchange from '../assets/refresh.png';
import rtn_policy from '../assets/product-return.png';
// import jwel1 from '../assets/27175.png';
// import jwel2 from '../assets/gold-ring.png';
// import model1 from '../assets/model-with-smokey-eyes-golden-circle-earrings.png';
// import model2 from '../assets/female-model-wedding-bridal-makeup-demonstrating-jewelry.png';
// import seller1 from '../assets/portrait-beautiful-fashion-woman-with-black-makeup-golden-manicure.png';
// import cat1 from '../assets/woman-yellow-summer-dress-with-short-hairstyle-boho-vintage-style-interior-room-posing.png';
// import PromoVideos from '../assets/Beautiful Diamond Rings design for girls 2022 __ Latest Diamond Engagement rings...mp4';
import user from '../assets/usernew.png';
// import card from '../assets/vecteezy_diamond-pendant-9k-gold_2460460.png';
// import ring from "../../src/assets/ring.png";
import certified from "../../src/assets/certified.jpg";
import reviewUser from "../../src/assets/review.png";
// import headerHeart from "../../src/assets/whislist-new.png";
// import headerbag from "../../src/assets/cart-new.png";
import left from "../../src/assets/left.png";
import right from "../../src/assets/right.png";
// import whishlistImg from "../../src/assets/whishlist-img.png";
// import whishlistBannerImg from "../../src/assets/whishlist-banner.png";
// import fav_list from "../../src/assets/fav_list.png";
// import contactBanner from "../../src/assets/contact-banner.png";
// import whishlistImg1 from "../../src/assets/jewel-1.png";
import insta from "../../src/assets/insta.png";
import tw from "../../src/assets/tw.png";
import fb from "../../src/assets/fb.png";
import web from "../../src/assets/web.png";
import locationImg from "../../src/assets/location-img.png";
import mailImg from "../../src/assets/mail-img.png";
import phoneImg from "../../src/assets/phone-img.png";
// import cardImg from "../../src/assets/card2.png";
// import collImg from "../../src/assets/collImg.webp";
// import collImg1 from "../../src/assets/collImg2.webp";
import nxtBtn from "../../src/assets/nextBtn.png";
import preBtn from "../../src/assets/preBtn.png";
// import check from "../../src/assets/check.png";
import emailIcon from "../../src/assets/email.png";
import password from "../../src/assets/password.png";
import phone_no from "../../src/assets/phone_no.png";
import refer from "../../src/assets/referral.png";
import hideEye from "../../src/assets/hideeye.png";
import tick from "../../src/assets/tick.png";
// import cancel from "../../src/assets/cancel.png";
// import banner3 from "../../src/assets/banner2.png";
// import girl1 from "../assets/girl1.png";
// import girl2 from "../assets/girl2.png";
// import service from "../assets/service.png";
// import homeIcon from "../assets/homeIcon.png";
// import offer from "../../src/assets/offer.png";
import delivery from "../../src/assets/delivery.png";
import returnPolicy from "../../src/assets/return.png";
import lifeExchange from "../../src/assets/life-exchange.png";
import offer_new from "../../src/assets/offer_new.png";
import grocery from "../../src/assets/grocery.png";
import wallet_new from "../../src/assets/wallet_new.png";
import about_main from "../../src/assets/about_main.jpg";
import about_first from "../../src/assets/about_first.jpg";
import about_second from "../../src/assets/about_second.jpg";
import logo_new from "../../src/assets/logo_new.png";
import user_new from "../../src/assets/user_new.png";






export const images = {
    Hlogo:logo,
    logo_new:logo_new,
    Fphone:phone,
    Fwhatsapp:whatsapp,
    Fmail:mail,
    FappleStore:apple,
    FpalyStore:play,
    Hsearch:search,

    // banner1: banner1,
    // banner2:banner2,
    // banner3:banner3,
    // girl1:girl1,
    // girl2:girl2,

    // BIS,
    delivery_van,
    Exchange,
    rtn_policy,
    
    // jwel1,
    // jwel2,
    // model1,
    // model2,
    // seller1,
    // cat1,
    // PromoVideos,
    user,
    // card,
    // Hring:ring,
    certi:certified,
    reviewUser,
    // headerbag,
    // headerHeart,
    left,
    right,
    // whishlistImg:whishlistImg,
    // whishlistBannerImg:whishlistBannerImg,
    // fav_list:fav_list,
    // whishlistImg1:whishlistImg1,
    // contactBanner:contactBanner,
    insta:insta,
    tw:tw,
    fb:fb,
    web:web,
    locationImg:locationImg,
    mailImg:mailImg,
    phoneImg:phoneImg,
    // cardImg,
    // collImg,
    // collImg1,
    nxtBtn,
    preBtn,
    emailIcon,
    password,
    phone_no,
    // check,
    refer,
    hideEye,
    tick,
    // cancel,
    // service,
    // homeIcon,
    // offer,
    delivery,
    lifeExchange,
    returnPolicy,
    offer_new,
    grocery,
    wallet_new,
    about_main,
    about_first,
    about_second,
    user_new
}